<template>
  <v-card width="200px" style="min-width: 200px; max-width: 200px;">
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field
          tabindex="1"
          type="number"
          hide-spin-buttons
          :label="$t('logLength')"
          v-model="logLength.length"
          @keydown.enter.prevent="addLogLength('enter')"
          @keydown="keydownHandler"
          :rules="getRules"
          :hint="getHint"
          persistent-hint
          ref="logLengthField">
            <template #append>
              <Icon
              tabindex="3"
              :tooltipText="$t('addLogLength')"
              :small="false"
              icon="mdi-check-circle"
              icon-color="success"
              @icon-clicked="addLogLength('click')"
              :disabled="!isValid"/>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import FormRules from '@/utils/rules.js'
import { MIN_LENGTH as MIN_LENGTH_SCALING, MAX_LENGTH as MAX_LENGTH_SCALING } from '@/components/account/account-scaling/log-lengths/LogLengths'

const MIN_LENGTH_PLF = 8
const MAX_LENGTH_PLF = 64

export default {
  name: 'LogLengthForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    propLogLength: {
      type: Object,
      required: false,
      default: () => ({
        length: null
      })
    },
    existingLengths: {
      type: Array,
      required: false,
      default: undefined
    },
    segmentLength: {
      type: Number,
      required: false,
      default: undefined
    },
    index: {
      type: Number,
      required: false,
      default: -1
    },
    isScaling: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  created () {
    this.logLength.length = this.propLogLength.length
  },

  mounted () {
    setTimeout(() => {
      this.$refs.logLengthField.focus()
    }, 50)
  },

  data: () => ({
    rules: FormRules.rules,
    logLength: {
      length: null
    }
  }),

  computed: {
    isValid () {
      const newLengthParsedFixed = Number(parseFloat(this.logLength.length).toFixed(2))
      const existing = this.existingLengths.filter(l => l.length !== this.propLogLength.length)
      const passesSegmentLength = !this.segmentLength || Number(this.segmentLength) <= newLengthParsedFixed
      const passesLogLength = this.isScaling ? this.logLengthRuleScaling(this.logLength.length) : this.logLengthRule(this.logLength.length)
      return passesLogLength &&
        existing.every(l => l.length !== newLengthParsedFixed) &&
        passesSegmentLength
    },

    getRules () {
      return this.isScaling
        ? [this.rules.positiveIntegerBetweenOrBlank(MIN_LENGTH_SCALING, MAX_LENGTH_SCALING, this.$t('scalingLogLength')), this.noDupesScaling]
        : [this.rules.decimalTwoPlacesBetweenOrBlank(MIN_LENGTH_PLF, MAX_LENGTH_PLF, 'validRangeForLogLength'), this.greaterThanSegmentLengthRule]
    },

    getHint () {
      if (this.isScaling && !this.propLogLength?.length) {
        return this.$t('commaSeparateToAddMultiple')
      }
      return undefined
    }
  },

  methods: {
    logLengthRule: FormRules.rules.decimalTwoPlacesBetweenOrBlank(MIN_LENGTH_PLF, MAX_LENGTH_PLF, false, false),
    logLengthRuleScaling: FormRules.rules.decimalTwoPlacesBetweenOrBlank(MIN_LENGTH_SCALING, MAX_LENGTH_SCALING, false, false),

    noDupesScaling () {
      return this.existingLengths.every(el => el.length !== parseInt(this.logLength.length)) || this.$t('cannotDuplicate')
    },

    greaterThanSegmentLengthRule (value) {
      if (!this.segmentLength) return true
      return !value || Number(this.segmentLength) <= value || this.$t('logLengthsMustBeGreaterThanSegmentLength')
    },

    addLogLength (confirmationMethod) {
      if (!this.isValid) return
      this.$emit('mutate-log-length',
        {
          newLength: {
            length: Number(parseFloat(this.logLength.length))
          },
          oldLength: {
            length: Number(parseFloat(this.propLogLength.length))
          },
          index: this.index,
          confirmationMethod: confirmationMethod
        })
      this.logLength.length = null
    },

    keydownHandler (e) {
      if (e.code.toLowerCase() === 'comma' && !this.propLogLength?.length) {
        this.addLogLength('comma')
      }
    }
  }
}
</script>
